export default __webpack_public_path__ + "static/media/sign-out-alt.752253ee.svg";